import React from "react";
import "./style.css";
import categorias from '../../assets/productos.json';
import SeoHead from '../../Components/SeoHead/SeoHead';
import { sortBy } from '../../Helpers/Helpers';

function Product() {
  return (
    <div className="container mx-auto px-4">
      <SeoHead
        title="Productos"
        path="/productos"
        description="Catálogo de mármoles, granitos y cuarzos de Marmolería Colaiacovo. Amplia variedad de materiales para encimeras, pisos y revestimientos en Buenos Aires."
      />
      <h1 className="py-8 text-center font-bold section-title">PRODUCTOS</h1>
      {sortBy(categorias, "order").map((categoria) => {
        return (
          <React.Fragment key={categoria.name}>
            {sortBy(categoria.subcategories, "order").map((subcategoria) => {
              return (
                <section key={`${categoria.name}-${subcategoria.name}`} id={categoria.name} className="mx-auto mb-8">
                  <h2 className="uppercase mb-5">{categoria.name} {subcategoria.name}</h2>
                  <div className="inline-flex flex-wrap justify-center gap">
                    {sortBy(subcategoria.products, "order").map((product, index) => {
                      return (
                        <div key={index} className="w-40 producto-container">
                          <div className="cursor-pointer img-hover-zoom overflow-hidden rounded-md producto-shadow producto-wrapper">
                            <img src={product.image} className="image-thumbnail object-cover h-40 w-40" alt={product.name}/>
                            <div className="producto-overlay">
                              <span>{product.name}</span>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </section>
              )})}
          </React.Fragment>
        )
      })}
    </div>
  );
}

export default Product;
